import { useQuery } from '@tanstack/vue-query';
import { type Ref, unref } from 'vue';

import { installationRiskService } from '~/services/installation-risk-api/installation-risk-api';

export default function useInvertersInfo(projectId: Ref<string> | string) {
  const _projectId = unref(projectId);
  return useQuery({
    enabled: () => Boolean(_projectId),
    queryFn: async () => {
      if (!_projectId) throw new Error(`Project ID is required. Received: ${_projectId}`);
      return installationRiskService.getInstalledInverters(_projectId);
    },
    queryKey: ['inverters-info', _projectId],
  });
}
